import * as React from 'react'

import type moment from 'moment'

import { observer } from 'mobx-react'

import { dateToString } from 'modules/core/lib/dates'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import EmptyCellActions from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/CellActions/EmptyCellActions'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import { useSelectionState } from 'modules/shift_management/hooks/useSelection'
import type ShiftsRow from 'modules/shift_management/store/internal/models/ShiftsRow'

interface EmptyCellProps {
  shiftsRow: ShiftsRow
  date: moment.Moment
  isOver: boolean
  contractVersions: ContractVersions
}

const EmptyCell = ({ date, shiftsRow, isOver, contractVersions }: EmptyCellProps) => {
  // Keep these selection hooks here, using this wrapper to be re-rendered
  // but we avoid to re-render the children unless the isSelected prop changes.
  const { daysByRow } = useSelectionState()
  const [{ view }] = useSchedule()

  const dayId = dateToString(date, view.dateFormat)
  const isSelected = (daysByRow[shiftsRow.key] || []).includes(dayId)

  return (
    <EmptyCellActions
      date={date}
      shiftsRow={shiftsRow}
      isSelected={isSelected}
      isOver={isOver}
      contractVersions={contractVersions}
    />
  )
}

export default observer(EmptyCell)
